export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20warm%20golden%20and%20crimson%20light%20beams%20radiating%20from%20center%20against%20deep%20charcoal%20background%2C%20soft%20film%20grain%20texture%2C%20elegant%20bokeh%20circles%2C%20atmospheric%20theater%20curtain%20folds%20in%20rich%20burgundy%20tones%2C%20dramatic%20lighting%2C%20editorial%20composition%2C%20no%20text%20no%20logos%20clean%20abstract%20cinematic%20mood&width=1920&height=960&seq=97cinema-hero-bg&orientation=landscape"
        alt="97影院 - 电视剧全集在线观看平台背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
        onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/90 text-foreground-950 mb-5 tracking-wide">
              每日更新 · 海量剧集 · 高清蓝光
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              97影院<span className="text-accent-400"> · </span>电视剧全集在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              热门国产剧、韩剧、美剧 — 你想看的，这里都有
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              97影院专注电视剧全集在线观看，汇集最新国产剧、热门韩剧、高分美剧，每日同步更新。无论你是古装迷、悬疑控还是甜宠爱好者，这里都能找到心头好。全站高清蓝光画质，加载流畅不卡顿，支持多设备观看，随时随地畅享追剧乐趣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">20000+</div>
                <div className="text-xs text-white/55 mt-1">部剧集资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
                <div className="text-xs text-white/55 mt-1">同步追剧不等待</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">蓝光画质</div>
                <div className="text-xs text-white/55 mt-1">流畅不卡顿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#index')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                开始追剧
              </button>
              <button
                onClick={() => handleScroll('#ranking')}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg border border-white/25 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                查看热播排行
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none flex justify-center">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20visual%20with%20warm%20golden%20and%20deep%20red%20gradient%2C%20elegant%20film%20strip%20silhouette%20curving%20through%20composition%2C%20soft%20lens%20flare%2C%20velvet%20curtain%20texture%20at%20edges%2C%20dramatic%20atmospheric%20mood%2C%20luxurious%20home%20theater%20aesthetic%2C%20no%20text%20clean%20editorial%20style&width=800&height=600&seq=97cinema-hero-visual&orientation=landscape"
                alt="97影院 - 沉浸式追剧体验"
                className="w-full h-full object-cover"
                onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}